// noinspection ES6UnusedImports

import type { Theme, Components } from '@mui/material/styles';
import {} from '@mui/x-data-grid/themeAugmentation';

import { CbridgePalette } from './theme.constant';

const grid = CbridgePalette.dataGrid;

export const MuiDataGrid: Components<Theme>['MuiDataGrid'] = {
  defaultProps: {
    density: 'compact',
  },
  styleOverrides: {
    main: ({ theme }) => ({
      '& .MuiDataGrid-row:not(.MuiDataGrid-odd-row):not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.normal.even.default,
        '&:hover': {
          backgroundColor: grid.normal.even.hover,
        },
        '&.Mui-selected': {
          backgroundColor: grid.normal.even.selected,
        },
        '&.Mui-selected:hover': {
          backgroundColor: grid.normal.even.selectedHover,
        },
      },
      '& .MuiDataGrid-row.MuiDataGrid-odd-row:not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.normal.odd.default,
        '&:hover': {
          backgroundColor: grid.normal.odd.hover,
        },
        '&.Mui-selected': {
          backgroundColor: grid.normal.odd.selected,
        },
        '&.Mui-selected:hover': {
          backgroundColor: grid.normal.odd.selectedHover,
        },
      },
      '& .MuiDataGrid-added-row.MuiDataGrid-row:not(.MuiDataGrid-odd-row):not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.added.even,
        '&:hover': {
          backgroundColor: grid.added.hover,
        },
      },
      '& .MuiDataGrid-added-row.MuiDataGrid-row.MuiDataGrid-odd-row:not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.added.odd,
        '&:hover': {
          backgroundColor: grid.added.hover,
        },
      },
      '& .MuiDataGrid-updated-row.MuiDataGrid-row:not(.MuiDataGrid-odd-row):not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.updated.even,
        '&:hover': {
          backgroundColor: grid.updated.hover,
        },
      },
      '& .MuiDataGrid-updated-row.MuiDataGrid-row.MuiDataGrid-odd-row:not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.updated.odd,
        '&:hover': {
          backgroundColor: grid.updated.hover,
        },
      },
      '& .MuiDataGrid-deleted-row.MuiDataGrid-row:not(.MuiDataGrid-odd-row):not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.deleted.even,
        '&:hover': {
          backgroundColor: grid.deleted.hover,
        },
      },
      '& .MuiDataGrid-deleted-row.MuiDataGrid-row.MuiDataGrid-odd-row:not(.MuiDataGrid-master-row)': {
        backgroundColor: grid.deleted.odd,
        '&:hover': {
          backgroundColor: grid.deleted.hover,
        },
      },
      '&&& .MuiDataGrid-subtotal-row': {
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: grid.masterRowBg,
        '&:hover': {
          backgroundColor: grid.masterRowHover,
        },
      },
      '& .MuiDataGrid-tree-group-row': {
        '&.Mui-selected': {
          backgroundColor: grid.normal.odd.selected,
        },
        '&.Mui-selected:hover': {
          backgroundColor: grid.normal.odd.selectedHover,
        },
      },
      '& .MuiDataGrid-master-row': {
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderColor: (theme.vars ?? theme).palette.divider,
        backgroundColor: CbridgePalette.background.h2,
        '&:hover': {
          backgroundColor: grid.masterRowHover,
        },
      },
      '&&& .MuiDataGrid-disabled-row': {
        backgroundColor: grid.disabledRowBg,
        '&:hover': {
          backgroundColor: grid.disabledRowBg,
        },
      },
      '&&& .MuiDataGrid-grayed-row': {
        color: theme.palette.text.disabled,
      },
      '& .MuiDataGrid-cell--equalValues': {
        color: theme.palette.success.main,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'transparent',
      },
      '& .MuiInputBase-input': {
        backgroundColor: 'transparent',
      },
      '& .MuiDataGrid-cell--editing': {
        backgroundColor: 'transparent !important',
      },

      '& .MuiDataGrid-columnHeader': {
        '&[aria-colindex="1"]': {
          borderTopLeftRadius: theme.shape.borderRadius,
        },
        '&.MuiDataGrid-columnHeader--last': {
          borderTopRightRadius: theme.shape.borderRadius,
        },
      },

      '& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader': {
        borderBottom: 'none',
      },
      '& .MuiDataGrid-filler *': {
        border: 'none',
      },

      '&:hover': {
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
          backgroundColor: CbridgePalette.scrollbar.thumb,
        },
        '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
          backgroundColor: CbridgePalette.scrollbar.thumb,
        },
        '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
          backgroundColor: CbridgePalette.scrollbar.thumb,
        },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
          backgroundColor: CbridgePalette.scrollbar.thumb,
        },
      },
    }),
    root: {
      border: 'none',
    },
    row: {
      '&:hover': {
        '& .CBridge-visible-on-hover': {
          opacity: 1,
          transition: 'opacity 0.3s linear',
        },
      },
      '& .CBridge-visible-on-hover': {
        opacity: 0,
      },
    },
    cell: {
      border: 'none',
      '&:focus, &:focus-within': {
        outline: 'none',
        backgroundColor: 'transparent',
      },
    },
    filler: {
    },
  },
};
